import styled from "styled-components";
import titleBackground from "../../Assets/aboutUs/titleBackground.svg";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  color: var(--secondary-color);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding-top: 120px;
  @media (min-width: 768px) {
    padding-top: 150px;
  }
`;

export const AboutContainer = styled.div`
  width: 90%;
`;
export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: normal;
  color: var(--secondary-color);
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 2rem;
  @media (min-width: 768px) {
    text-align: start;
    font-size: 2rem;
    border-bottom-right-radius: 50px;
    color: var(--details-color);
    background-image: url(${titleBackground});
    background-repeat: no-repeat;
    background-size: cover;
    padding: 1rem;
  }
`;
export const Subtitle = styled.h3`
  line-height: 3rem;
  @media (min-width: 768px) {
    padding-left: 1rem;
  }
`;
export const Content = styled.p`
  line-height: 2rem;
  ::first-letter {
    padding-left: 2rem;
  }
  @media (min-width: 768px) {
    padding-left: 1rem;
  }
`;

export const TeamContainer = styled.div`
  width: 50%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  @media (min-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;
export const MemberContainer = styled.figure`
  height: 185px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 768px) {
    margin-top: 2rem;
  }
`;
export const MemberName = styled.figcaption``;
export const MemberPhoto = styled.img``;
export const MemberLinkedin = styled.a``;
export const Icon = styled.img`
  width: 80px;
`;
export const Button = styled.button`
  padding: 0.5rem 0.5rem;
  font-size: 1.5rem;
  font-weight: normal;
  background-color: var(--tertiary-color-main-buttons);
  color: var(--primary-color);
  border-radius: 8px;
  margin-top: 5rem;
  margin-bottom: 15rem;
  border: 2px solid var(--tertiary-color-main-buttons);
  :hover {
    background-color: var(--primary-color);
    color: var(--tertiary-color-main-buttons);
  }
`;
